import { pick } from 'ramda';
import { useEffect, useState } from 'react';
import { usePrevious } from 'js/hooks/usePrevious';
import { useDynamicReducerSelector } from './store';

export const useDeltaChanged = () => {
    const { deltaX, deltaY, started } = useDynamicReducerSelector(pick(['deltaX', 'deltaY', 'started']));
    const [deltaChanged, setDeltaChanged] = useState(false);
    const prevDeltaX = usePrevious(deltaX);
    const prevDeltaY = usePrevious(deltaY);

    useEffect(() => {
        const nextDeltaChanged = prevDeltaX !== deltaX || prevDeltaY !== deltaY;

        if (!started && deltaChanged !== nextDeltaChanged) {
            setDeltaChanged(nextDeltaChanged);
        }
    }, [started, deltaX, deltaY, prevDeltaX, prevDeltaY, deltaChanged]);

    return deltaChanged;
};
